import { Box, Flex, Progress, Text } from "@chakra-ui/react";
import { BrandLayout } from "__generated__/gql/graphql";
import { APP_NAME } from "utils/config";
import { useCurrentBrandData } from "utils/currentUserHooks";
import { formatInteger } from "utils/formatting";
import StatusIcon from "./StatusIcon";

type Props = {
  completedCount: number | undefined;
  isCompleted: boolean;
  totalCount: number;
};

export default function WidgetSummary({
  completedCount,
  isCompleted,
  totalCount,
}: Props) {
  const brand = useCurrentBrandData();
  const isAnalyticsLayout = brand?.layout === BrandLayout.ANALYTICS;

  return (
    <Box minWidth={0}>
      <Flex
        alignItems="center"
        gap={3}
        minWidth={0}
        pr={isCompleted ? 10 : undefined}
      >
        <StatusIcon isCompleted={isCompleted} />

        <Box minWidth={0}>
          <Text
            color={isCompleted ? "green.600" : "pink.500"}
            fontSize="xs"
            fontWeight="700"
            textTransform="uppercase"
          >
            {isCompleted ? "Setup Complete" : "Finish setup"}
          </Text>
          <Text color="magenta.veryDark" fontSize="sm" fontWeight="700">
            {isCompleted && `Get more from ${APP_NAME}`}
            {!isCompleted &&
              completedCount !== undefined &&
              `${formatInteger(completedCount)} of ${formatInteger(
                totalCount,
              )} steps done`}
          </Text>
        </Box>
      </Flex>

      {completedCount !== undefined && (
        <Progress
          value={(completedCount / totalCount) * 100}
          colorScheme={isCompleted ? "green" : "pink"}
          size="xs"
          borderRadius="full"
          mt={3}
        />
      )}

      <Text color="gray.600" fontSize="xs" mt={2} whiteSpace="normal">
        {isCompleted
          ? "Tap to watch a quick video or visit resources."
          : `Add products${
              isAnalyticsLayout ? "" : " and retailers"
            } to complete setup.`}
      </Text>
    </Box>
  );
}
